exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".hAmfJgKWDehPx6NikTkqZ{display:inline-block}\n", ""]);

// Exports
exports.locals = {
	"InviteButton": "hAmfJgKWDehPx6NikTkqZ"
};